export default {
  primaryColor: "#2D55EB",
  secondaryColor: "#FFC400",
  successColor: "",
  warningColor: "#DD391E",
  infoColor: "",
  mainColor: "#fff",
};
